import blog1 from "@assets/images/meeting-with-client-for-gathering-requirements.avif";
import blog2 from "@assets/images/brainstorming-the-best-software-solutions.avif";
import blog3 from "@assets/images/website-designers-discussing-low-fidelity-mockups.avif";
import blog4 from "@assets/images/coding-on-a-computer.avif";
import blog5 from "@assets/images/software-testing.avif"; 

export const process = [ 
  {
    title: "Discovery & Planning",
    image: blog1,
    description:
      "We define your technical requirements and a feature roadmap that aligns with your business goals.",
  },
  { 
    title: "UI/UX Design",
    image: blog2,
    description:
      "Creating high-fidelity wireframes and prototypes that adhere to iOS and Android design conventions.",
  },
  {
    title: "Platform-Specific Development",
    image: blog3,
    description:
      "Native coding where our experts build your app’s architecture.",
  },
  {
    title: "Testing ",
    image: blog4,
    description:
      "We perform unit, integration, and beta testing via TestFlight and Firebase to ensure a bug-free launch.",
  },
  {
    title: "Launch & Support",
    image: blog5,
    description:
      "We handle the entire store submission process and provide ongoing maintenance for new OS updates.",
  },
 
]; 